import { styled } from '@/styled-system/jsx';

export const FeesContainerWrapper = styled('div', {
  base: {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'token(colors.hpxGrey400)',
    borderRadius: '4px',
    width: '100%',
    marginTop: '2x',
    _first: {
      marginTop: '0px',
    },
  },
});

export const TitleContainer = styled('div', {
  base: {
    backgroundColor: 'rgb(246, 246, 250)',
    borderRadius: '4px',
    padding: '2x',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
});

export const HeaderTitle = styled('div', {
  base: {
    color: 'rgb(42, 42, 51)',
    fontSize: 'md',
    fontWeight: 700,
    lineHeight: 'md',
    width: '100%',
    backgroundColor: 'transparent',
    padding: '0',
    margin: '0',
  },
});

export const DisclaimerText = styled('div', {
  base: {
    fontSize: 'sm',
    color: 'rgb(89, 107, 130)',
    marginTop: '2px',
  },
});

export const FeesSection = styled('div', {
  base: {
    display: 'flex',
    flexDirection: {
      base: 'column',
      lg: 'row',
    },
    flexWrap: 'wrap',
    gap: '2x',
    justifyContent: 'space-between',
    padding: '2x',
    width: '100%',
    overflowX: 'visible !important',
    overflowY: 'visible !important',
    position: 'relative',
    isolation: 'isolate',
  },
});

export const SectionTitle = styled('p', {
  base: {
    fontWeight: 700,
    fontSize: 'sm',
    lineHeight: 'md',
  },
});

export const PriceRow = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'row',
    gap: '2x',
    justifyContent: 'space-between',
    width: '100%',
  },
});

export const PriceGroup = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2x',
    flex: {
      base: '0 0 100%',
      lg: '0 1 calc(50% - 8px)',
    },
    maxWidth: {
      lg: 'calc(50% - 8px)',
    },
  },
});

export const Title = styled('div', {
  base: {
    backgroundColor: 'rgb(246, 246, 250)',
    color: 'rgb(42, 42, 51)',
    fontSize: 'md',
    fontWeight: 700,
    lineHeight: 'md',
    padding: '2x',
    width: '100%',
  },
});

export const Footer = styled('div', {
  base: {
    borderTopWidth: '1px',
    borderTopStyle: 'solid',
    borderTopColor: 'token(colors.hpxGrey400)',
    display: 'flex',
    flexDirection: 'row',
    fontSize: 'md',
    fontWeight: 700,
    justifyContent: 'space-between',
    lineHeight: 'md',
    padding: '2x',
    width: '100%',
  },
});

export const FooterPrice = styled('span', {
  base: {
    fontWeight: 700,
    fontSize: 'lg',
    lineHeight: 'md',
  },
});
